var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pui-dam-file-viewer',{staticClass:"file-gallery-item-thumbnail-viewer-root",attrs:{"file":_vm.file,"objectFit":_vm.objectFit,"delayDownloadLength":_vm.thumbnailDelayDownloadLength,"preventDownload":_vm.preventThumbnailDownload,"classImg":"file-gallery-item-image"}})
}
var staticRenderFns = []

export { render, staticRenderFns }